import React from 'react';

export function BarChart({ data = [], barColor = '#0F3D5C', height = 68 }) {
  if (!data.length) return null;
  const BAR_AREA = height - 18;
  const max = Math.max(...data.map((d) => d.value), 1);

  return (
    <div className="flex items-end gap-1.5 w-full" style={{ height }}>
      {data.map((d, i) => {
        const barH = d.value > 0 ? Math.max(Math.round((d.value / max) * BAR_AREA), 3) : 0;
        return (
          <div
            key={i}
            className="flex flex-col items-center flex-1"
            style={{ height, justifyContent: 'flex-end' }}
          >
            <div
              className="w-full rounded-sm transition-all duration-300"
              style={{ height: barH, backgroundColor: barColor, opacity: 0.82 }}
              title={`${d.label}: ${d.value}`}
            />
            <span className="text-[9px] text-slate-400 mt-1 select-none leading-none">
              {d.label}
            </span>
          </div>
        );
      })}
    </div>
  );
}

export default BarChart;
